import GlobalEventBus, { eventMessages } from 'Services/GlobalEventBus'
import StoreInstances, { getStoreFor } from 'Stores/StoreInstances'

import BaseStore from 'Stores/base_store/BaseStore'
import Users from 'DataServices/Users'
import { action } from 'mobx'

const STORE_TYPE = 'Users'

export function getUsersStoreFor (param, opts = {}) {
  return getStoreFor(UsersStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

GlobalEventBus.subscribe(eventMessages.TAX_DOCUMENT_ADDED, data => {
  if (data.resourceType === 'User') {
    StoreInstances.storesContainingRecord(STORE_TYPE, data.resourceId).forEach(store => {
      store.reload()
    })
  }
})

export class UsersStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: true,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  create (user) {
    return Users.create(user)
      .then(user => {
        StoreInstances._propagateChanges(STORE_TYPE, [user])
        return user
      })
  }

  @action
  _fetchAll (overridePayload) {
    let payload = overridePayload || {
      ...this._filter,
    }
    return Users.getAll(payload)
  }

  @action
  _fetchOne () {
    return Users.getById(this._filter.id)
  }
}
